module.exports = __webpack_public_path__ + "img/9bae5753ef8849cdf63f3322e43b1f15.png";